module.exports = __webpack_public_path__ + "0be0324bc3eb7d58090e725e437b55f7.svg";